
import { defineComponent, computed } from "vue";
import { store } from "@/store";
import { CurrentLabel } from "@/types";
import { ActionTypes } from "@/store/actions";

export default defineComponent({
  name: "LabelSizesButton",
  setup() {
    const currentLabel = computed<CurrentLabel>(() => store.getters.currentLabel);

    const showLabelSizes = () => {
      store.dispatch(ActionTypes.SET_MODAL, "labelSizes");
    }

    return {
      currentLabel,
      showLabelSizes
    };
  },
});
